/**
 * PATH: apps/ai/src/pages/dashboard/QuickActionButton.tsx
 * PURPOSE: Quick action button for Intelligence sidebar
 */

import { ChevronRight } from 'lucide-react';
import { cn } from '../../lib/utils';

const colorMap = {
  teal: "from-teal-500 to-emerald-600",
  blue: "from-blue-500 to-indigo-600",
  amber: "from-amber-500 to-orange-600",
  purple: "from-purple-500 to-pink-600",
  red: "from-red-500 to-rose-600",
};

interface QuickActionButtonProps {
  icon: React.ComponentType<{ className?: string }>;
  title: string;
  description?: string;
  onClick: () => void;
  color?: keyof typeof colorMap;
}

export function QuickActionButton({ icon: Icon, title, description, onClick, color = "teal" }: QuickActionButtonProps) {
  return (
    <button onClick={onClick} className="group flex items-center gap-2.5 p-2.5 rounded-xl bg-card border border-border hover:border-primary/30 hover:shadow-md transition-all text-left w-full">
      <div className={cn("p-2 rounded-lg bg-gradient-to-br text-white shadow-sm", colorMap[color])}>
        <Icon className="w-3.5 h-3.5" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-xs font-semibold text-foreground group-hover:text-primary transition-colors">{title}</p>
        {description && <p className="text-[9px] text-muted-foreground truncate">{description}</p>}
      </div>
      <ChevronRight className="w-3.5 h-3.5 text-muted-foreground group-hover:text-primary transition-all" />
    </button>
  );
}
